import React, { Fragment, useState, useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import groupBy from 'lodash/groupBy';
import keys from 'lodash/keys';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import moment from 'moment-timezone';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import AvatarWithFallback, { ICON_COLOR } from '@scoir/avatar';
import AvatarWithTitle, { Title } from '@scoir/avatar-with-title';
import { imageAsFullImageSrc } from '@scoir/avatar-image-url';
import { jsx, jsxs } from 'react/jsx-runtime';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { makeStyles, alpha } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faClock, faSearch, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { useRelativeTime, formatter, isCredibleDate } from '@scoir/date';
import isUndefined from 'lodash/isUndefined';
import update from '@scoir/immutability';
import { DismissibleDialog, ConfirmationDialog } from '@scoir/modals';
import some from 'lodash/some';
import get from 'lodash/get';
import noop from 'lodash/noop';
import findIndex from 'lodash/findIndex';
import reject from 'lodash/reject';
import trim from 'lodash/trim';
import isEqual from 'lodash/isEqual';
import IconButton from '@material-ui/core/IconButton';
import { faComment, faLink, faPencil, faArrowLeft, faCheck } from '@fortawesome/pro-solid-svg-icons';
import size from 'lodash/size';
import Alert from '@material-ui/lab/Alert';
import { EmptyStateWithAction, BasicEmptyState } from '@scoir/empty-state';
import sanitizeHtml from 'sanitize-html';
import head from 'lodash/head';
import includes from 'lodash/includes';
import reduce from 'lodash/reduce';
import trimStart from 'lodash/trimStart';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CollegeCrest from '@scoir/college-crest';
import debounce from 'lodash/debounce';
import { Link } from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import take from 'lodash/take';
import moment$1 from 'moment';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Badge from '@material-ui/core/Badge';
import { format } from 'date-fns';
import Link$1 from '@material-ui/core/Link';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';

const getAvatar = (participant, studentPhotoEnabled) => participant.StudentPhotoUrl && studentPhotoEnabled ? participant.StudentPhotoUrl : participant.AvatarUrl;

var LABELS = {
  ParticipantParent: 'Parent',
  ParticipantCounselor: 'Counselor',
  ParticipantHighSchoolStudent: 'Student',
  ParticipantRep: 'Contact'
};

let Conversation$1 = class Conversation extends React.Component {
  static propTypes = {
    conversation: PropTypes.array.isRequired,
    ownerId: PropTypes.string.isRequired,
    participants: PropTypes.array.isRequired,
    studentPhotoEnabled: PropTypes.bool,
    conversationFlowHeadingType: PropTypes.string
  };
  static defaultProps = {
    conversationFlowHeadingType: 'h3'
  };
  state = {
    groupedConversation: []
  };
  formatConversation(rawConversation) {
    const withSenders = map(rawConversation, conversation => {
      const sender = find(this.props.participants, {
        ParticipantId: conversation.SenderId
      });
      conversation.Sender = sender;
      return conversation;
    });
    const orderedBySendDate = orderBy(withSenders, ['SentOn'], ['asc']);
    return groupBy(orderedBySendDate, record => {
      return moment(record.SentOn).startOf('day').format('MMM Do, YYYY');
    });
  }
  updateConversation(conversation) {
    const groupedConversation = this.formatConversation(conversation);
    this.setState({
      sortedMessageDates: keys(groupedConversation),
      groupedConversation
    });
    setTimeout(() => {
      if (this.compRef === null) {
        return;
      }
      this.compRef.scrollTop = this.compRef.scrollHeight;
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.conversation !== this.props.conversation) {
      this.updateConversation(this.props.conversation);
    }
  }
  componentDidMount() {
    this.updateConversation(this.props.conversation);
  }
  render() {
    const {
      studentPhotoEnabled,
      conversationFlowHeadingType: HeadingType
    } = this.props;
    return /*#__PURE__*/jsx("div", {
      className: "conversation-flow-comp",
      ref: ref => this.compRef = ref,
      children: map(this.state.sortedMessageDates, date => {
        return /*#__PURE__*/jsxs("div", {
          className: "day-grouping",
          children: [/*#__PURE__*/jsx(HeadingType, {
            className: "date",
            children: date
          }), this.state.groupedConversation[date].map(record => {
            const isSelf = record.SenderId === this.props.ownerId;
            const isSystemMessage = !has(record, 'SenderId');
            const avatarUrl = record.Sender ? getAvatar(record.Sender, studentPhotoEnabled) : '';
            return /*#__PURE__*/jsxs("div", {
              className: cn('message-wrapper', {
                self: isSelf
              }),
              children: [!isSelf && !isEmpty(record.Sender) && !isSystemMessage && /*#__PURE__*/jsx(AvatarWithTitle, {
                alignItems: 'center',
                avatar: /*#__PURE__*/jsx(AvatarWithFallback, {
                  size: "sm",
                  variant: "circular",
                  iconColor: ICON_COLOR.info,
                  color: ICON_COLOR.info,
                  sourceUrl: avatarUrl ? imageAsFullImageSrc(avatarUrl) : undefined,
                  fallbackIcon: record.Sender.Name.charAt(0) ?? '?',
                  "aria-label": record.Sender.Name,
                  name: record.Sender.Name
                }),
                title: /*#__PURE__*/jsx(Title, {
                  children: record.Sender.Name
                }),
                children: /*#__PURE__*/jsx(Typography, {
                  variant: "body2",
                  color: "textSecondary",
                  children: LABELS[record.Sender.Type]
                })
              }), isSystemMessage ? /*#__PURE__*/jsxs("div", {
                className: "disconnected-message-wrapper",
                children: [/*#__PURE__*/jsx("div", {
                  className: "disconnected-message-time",
                  children: moment(record.SentOn).format('ddd, MMM D, h:mmA')
                }), /*#__PURE__*/jsx("div", {
                  className: "disconnected-message",
                  dangerouslySetInnerHTML: {
                    __html: record.Message
                  }
                })]
              }) : /*#__PURE__*/jsxs(Box, {
                children: [/*#__PURE__*/jsx(Box, {
                  marginLeft: isSelf ? 'auto' : 'unset',
                  className: "message",
                  dangerouslySetInnerHTML: {
                    __html: record.Message
                  }
                }), /*#__PURE__*/jsx(Box, {
                  justifyContent: isSelf ? 'flex-end' : 'flex-start',
                  className: "message-time",
                  children: moment(record.SentOn).format('h:mm:ss A')
                })]
              })]
            }, record.Id);
          })]
        }, date);
      })
    });
  }
};

var parseUrl = (text => {
  const urlPattern = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/gi;
  return text.replace(urlPattern, '<a target="_blank" rel="noopener" href="$&">$&</a>');
});

const CONVERSATION_INPUT_ID = 'msgctr-conversation-input-id';
const hasMessage = message => message.replace(/<br>|^\s|^\n|^\r/g, '') !== '';
class ConversationInput extends React.Component {
  static propTypes = {
    onSendMessage: PropTypes.func.isRequired,
    allowEnterToSendToggle: PropTypes.bool,
    sanitizeFn: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired
  };
  static defaultProps = {
    allowEnterToSendToggle: true,
    disabled: false,
    readOnly: false
  };
  state = {
    message: '',
    isEnterToSend: false,
    isSendEnabled: false
  };
  updateMessage(message) {
    let isSendEnabled = false;
    if (hasMessage(message)) {
      isSendEnabled = true;
    }
    this.setState({
      message,
      isSendEnabled
    });
  }
  formatMessage(rawMessage) {
    const sanitized = this.props.sanitizeFn(rawMessage) || '';
    const urlParsed = parseUrl(sanitized);
    return urlParsed.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
  sendMessage() {
    const formattedMessage = this.formatMessage(this.state.message);
    if (hasMessage(formattedMessage)) {
      this.props.onSendMessage(formattedMessage);
    }
    this.setState({
      message: '',
      isSendEnabled: false
    });
  }
  keyUp(e) {
    const canSend = e.key === 'Enter' && this.state.isEnterToSend && !this.props.disabled && this.state.isSendEnabled && !e.shiftKey;
    if (canSend) {
      this.sendMessage();
    }
  }
  render() {
    const messageLabel = this.props.readOnly ? 'This conversation has been deactivated' : 'Write message here...';
    return /*#__PURE__*/jsx(Paper, {
      className: "conversation-input-comp",
      elevation: 0,
      variant: "outlined",
      children: /*#__PURE__*/jsxs(Box, {
        py: 1,
        px: 2,
        children: [/*#__PURE__*/jsx(TextField, {
          id: CONVERSATION_INPUT_ID,
          placeholder: messageLabel,
          multiline: true,
          fullWidth: true,
          minRows: 6,
          variant: "outlined",
          value: this.state.message,
          onKeyUp: e => this.keyUp(e),
          onChange: e => this.updateMessage(e.target.value)
        }), !this.props.readOnly && /*#__PURE__*/jsxs(Box, {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          pt: 1,
          children: [this.props.allowEnterToSendToggle && /*#__PURE__*/jsx(FormControlLabel, {
            checked: this.state.isEnterToSend,
            control: /*#__PURE__*/jsx(Checkbox, {
              title: "press enter to send",
              disableRipple: false,
              color: "primary",
              onChange: e => this.setState({
                isEnterToSend: e.target.checked
              })
            }),
            label: "Press enter to send"
          }), !this.state.isEnterToSend && /*#__PURE__*/jsx(Button, {
            color: "primary",
            variant: "contained",
            onClick: () => this.sendMessage(),
            disabled: !this.state.isSendEnabled || this.props.disabled,
            children: "Send"
          })]
        })]
      })
    });
  }
}

class ListItemDelete extends React.Component {
  static propTypes = {
    onDelete: PropTypes.func
  };
  state = {
    deleting: false
  };
  handleDelete = e => {
    e.stopPropagation();
    if (!this.state.deleting) {
      this.setState({
        deleting: true
      });
      if (this.props.onDelete()) {
        this.props.onDelete().finally(() => this.setState({
          deleting: false
        }));
      } else {
        this.setState({
          deleting: false
        });
      }
    }
  };
  render() {
    if (isUndefined(this.props.onDelete)) {
      return null;
    }
    return /*#__PURE__*/jsx("div", {
      className: "msgctr-list-item-delete-comp",
      "aria-label": "delete",
      role: "button",
      tabIndex: 0,
      onKeyPress: e => (e.key === ' ' || e.key === 'Enter') && this.handleDelete(e),
      onClick: this.handleDelete,
      children: /*#__PURE__*/jsx(FontAwesomeIcon, {
        icon: faTimes
      })
    });
  }
}

const useClasses$2 = makeStyles(theme => ({
  msgctrInboxItemComp: {
    '&.msgctr-selected': {
      borderLeftColor: theme.palette.primary.main
    },
    '&:not(.msgctr-selected):hover': {
      borderLeftColor: theme.palette.primary.light
    }
  }
}));
const InboxItemPreview = _ref => {
  let {
    body,
    createdDate,
    image,
    subject,
    isSelected,
    isUnread,
    onDelete,
    onSelect
  } = _ref;
  const classes = useClasses$2();
  const realativeTime = useRelativeTime(createdDate);
  return /*#__PURE__*/jsx(Box, {
    className: cn('msgctr-inbox-item-comp', classes.msgctrInboxItemComp, {
      'msgctr-unread': isUnread,
      'msgctr-selected': isSelected
    }),
    children: /*#__PURE__*/jsxs("div", {
      className: "msgctr-item-container",
      children: [/*#__PURE__*/jsxs("div", {
        className: "msgctr-item-content-wrapper",
        role: "button",
        tabIndex: 0,
        onKeyDown: e => (e.key === ' ' || e.key === 'Enter') && onSelect(),
        onClick: onSelect,
        children: [image && /*#__PURE__*/jsx("div", {
          className: "msgctr-item-image",
          children: image
        }), /*#__PURE__*/jsxs(Box, {
          className: "msgctr-item-content-text",
          children: [/*#__PURE__*/jsx(Typography, {
            className: "msgctr-subject msgctr-truncated",
            children: subject
          }), /*#__PURE__*/jsxs("div", {
            className: "msgctr-message",
            children: [/*#__PURE__*/jsx(Typography, {
              variant: "body2",
              className: "msgctr-body msgctr-truncated",
              children: body
            }), /*#__PURE__*/jsxs(Box, {
              mt: 0.5,
              display: "flex",
              alignItems: "center",
              className: "msgctr-time",
              children: [/*#__PURE__*/jsx(Box, {
                mr: 1,
                children: /*#__PURE__*/jsx(FontAwesomeIcon, {
                  "aria-hidden": true,
                  icon: faClock,
                  size: "sm"
                })
              }), /*#__PURE__*/jsx(Typography, {
                variant: "body2",
                children: realativeTime
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/jsx(ListItemDelete, {
        onDelete: onDelete
      })]
    })
  });
};
InboxItemPreview.propTypes = {
  body: PropTypes.string,
  createdDate: PropTypes.string,
  image: PropTypes.any,
  subject: PropTypes.string,
  isSelected: PropTypes.bool,
  isUnread: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onDelete: PropTypes.func
};
InboxItemPreview.defaultProps = {
  isSelected: false,
  isUnread: false
};

const ClassNameWrapper = _ref => {
  let {
    children,
    className,
    passedDownClassName,
    ...rest
  } = _ref;
  return /*#__PURE__*/jsx(Box, {
    className: cn(className, passedDownClassName),
    ...rest,
    children: children
  });
};
ClassNameWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  passedDownClassName: PropTypes.string
};

// --------------------------------------------------

const InboxPageWrapper = _ref2 => {
  let {
    children,
    className
  } = _ref2;
  return /*#__PURE__*/jsx(ClassNameWrapper, {
    className: "msgctr-inbox-page-wrapper",
    passedDownClassName: className,
    children: children
  });
};
InboxPageWrapper.propTypes = {
  children: ClassNameWrapper.propTypes.children,
  className: ClassNameWrapper.propTypes.className
};

// --------------------------------------------------

const InboxPageRail = _ref3 => {
  let {
    children,
    className
  } = _ref3;
  return /*#__PURE__*/jsx(ClassNameWrapper, {
    className: "msgctr-inbox-page-rail",
    passedDownClassName: className,
    width: {
      sm: '275px',
      md: '375px'
    },
    children: children
  });
};
InboxPageRail.propTypes = InboxPageWrapper.propTypes;

// --------------------------------------------------

const InboxPageMessageDisplay = _ref4 => {
  let {
    children,
    className
  } = _ref4;
  return /*#__PURE__*/jsx(ClassNameWrapper, {
    className: "msgctr-inbox-page-display",
    passedDownClassName: className,
    children: children
  });
};
InboxPageMessageDisplay.propTypes = InboxPageWrapper.propTypes;

class ConversationInputWithApi extends React.Component {
  static propTypes = {
    participantIds: PropTypes.array.isRequired,
    onAddMessage: PropTypes.func.isRequired
  };
  state = {
    conversation: []
  };
  addMessage(newMessage) {
    this.props.onAddMessage(this.props.participantIds, newMessage);
  }
  render() {
    return /*#__PURE__*/jsx(ConversationInput, {
      ...this.props,
      onSendMessage: newMessage => this.addMessage(newMessage),
      sanitizeFn: text => sanitizeHtml(text)
    });
  }
}

const Conversation = _ref => {
  let {
    discussionOwnerId,
    conversationFlowHeadingType,
    studentPhotoEnabled,
    errorMessage,
    readOnly,
    emptyStateHelper,
    conversation = [],
    participants = [],
    onAddMessage,
    onStartNewThread,
    onNavigateToProfile = noop
  } = _ref;
  return /*#__PURE__*/jsxs("div", {
    className: "msgctr-conversation-comp",
    children: [size(conversation) > 0 && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("div", {
        className: "msgctr-conversation-flow-wrapper",
        children: /*#__PURE__*/jsx(Conversation$1, {
          ownerId: discussionOwnerId,
          conversationFlowHeadingType: conversationFlowHeadingType,
          studentPhotoEnabled: studentPhotoEnabled,
          conversation: conversation,
          participants: participants
        })
      }), errorMessage && /*#__PURE__*/jsx(Alert, {
        severity: "error",
        icon: false,
        children: errorMessage
      }), /*#__PURE__*/jsx("div", {
        className: "msgctr-conversation-input-wrapper",
        children: /*#__PURE__*/jsx(ConversationInputWithApi, {
          readOnly: readOnly,
          onAddMessage: onAddMessage,
          participantIds: map(participants, 'ParticipantId')
        })
      }), size(participants) > 2 && /*#__PURE__*/jsx("div", {
        className: "msgctr-group-dm-warning",
        children: "*This message contains more than one recipient, use caution when sharing private details."
      })]
    }), size(conversation) === 0 && /*#__PURE__*/jsx("div", {
      className: "msgctr-empty-wrapper",
      children: /*#__PURE__*/jsx(EmptyStateWithAction, {
        title: emptyStateHelper ? 'Start a new conversation' : 'Make some connections',
        subTitle: emptyStateHelper ? 'Message linked counselors and supporters' : 'To start messaging, first link with your counselor and supporters.',
        icon: emptyStateHelper ? faComment : faLink,
        actionProps: {
          children: emptyStateHelper ? 'New Message' : 'Go to Profile',
          onClick: () => {
            emptyStateHelper ? onStartNewThread() : onNavigateToProfile();
          }
        }
      })
    })]
  });
};
Conversation.propTypes = {
  conversation: PropTypes.array,
  participants: PropTypes.array,
  discussionOwnerId: PropTypes.string.isRequired,
  onAddMessage: PropTypes.func.isRequired,
  emptyConversationComponent: PropTypes.node,
  errorMessage: PropTypes.string,
  readOnly: PropTypes.bool,
  studentPhotoEnabled: PropTypes.bool,
  conversationFlowHeadingType: PropTypes.string,
  emptyStateHelper: PropTypes.bool,
  onStartNewThread: PropTypes.func,
  onNavigateToProfile: PropTypes.func
};

const DISCUSSION_ID = 'msgctr-discussion-wrapper-id';
const unformatLastMessage = lastMessage => {
  const text = lastMessage.Message;
  return text.replace(/<br ?\/?>/g, ' ').replace(/<[^>]+>/g, '');
};
const formatSent = lastMessage => {
  return formatter.format(lastMessage.SentOn, {
    outputFormat: 'MM/DD/YYYY'
  });
};
const useClasses$1 = makeStyles(theme => ({
  msgctrDiscussion: {
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.05)
    },
    '&.msgctr-active': {
      backgroundColor: alpha(theme.palette.primary.main, 0.1)
    }
  },
  selectableWrapper: {
    borderLeft: '5px solid transparent',
    '&.msgctr-active': {
      borderLeft: `5px solid ${theme.palette.primary.main}`
    },
    '&.msgctr-unread': {
      borderLeft: `5px solid ${theme.palette.primary.light}`
    }
  }
}));
const DiscussionInbox = _ref => {
  let {
    discussions,
    activeDiscussionId,
    onDiscussionSelect,
    onDiscussionDelete,
    studentPhotoEnabled
  } = _ref;
  const classes = useClasses$1();
  return /*#__PURE__*/jsxs("div", {
    className: "msgctr-discussion-inbox-comp",
    children: [/*#__PURE__*/jsx(Typography, {
      component: "h2",
      variant: "srOnly",
      id: DISCUSSION_ID,
      children: "Messages"
    }), /*#__PURE__*/jsx("div", {
      "aria-labelledby": DISCUSSION_ID,
      children: discussions.map(discussion => {
        const otherParticipants = reject(discussion.Participants, ['ParticipantId', discussion.OwnerId]);
        const lastMessage = head(orderBy(discussion.Messages, ['SentOn'], ['desc']));
        return /*#__PURE__*/jsxs(Box, {
          className: cn('msgctr-discussion', classes.msgctrDiscussion, {
            'msgctr-active': activeDiscussionId === discussion.Id,
            'msgctr-unread': !discussion.Read
          }),
          children: [/*#__PURE__*/jsxs(Box, {
            className: cn('msgctr-selectable-wrapper', classes.selectableWrapper, {
              'msgctr-active': activeDiscussionId === discussion.Id,
              'msgctr-unread': !discussion.Read
            }),
            tabIndex: "0",
            role: "button",
            onKeyDown: e => e.key === 'Enter' && onDiscussionSelect(discussion),
            onClick: () => onDiscussionSelect(discussion),
            children: [/*#__PURE__*/jsx("div", {
              className: "msgctr-avatars",
              children: map(otherParticipants, (participant, idx) => {
                const avatarUrl = participant ? getAvatar(participant, studentPhotoEnabled) : '';
                return /*#__PURE__*/jsx("span", {
                  className: "msgctr-avatar-wrapper",
                  style: {
                    width: 100 / discussion.Participants.length + '%',
                    zIndex: discussion.Participants.length - idx
                  },
                  children: /*#__PURE__*/jsx(Box, {
                    ml: -2,
                    display: "inline-block",
                    p: "2px",
                    children: /*#__PURE__*/jsx(AvatarWithFallback, {
                      size: "xs",
                      variant: "circular",
                      iconColor: ICON_COLOR.info,
                      color: ICON_COLOR.info,
                      sourceUrl: avatarUrl ? imageAsFullImageSrc(avatarUrl) : undefined,
                      fallbackIcon: participant.Name.charAt(0) ?? '?',
                      "aria-label": participant.Name,
                      name: participant.Name
                    })
                  })
                }, idx);
              })
            }), /*#__PURE__*/jsx("div", {
              className: "msgctr-participant-wrapper",
              children: /*#__PURE__*/jsxs("div", {
                className: "msgctr-participant-content",
                children: [otherParticipants.length > 0 && /*#__PURE__*/jsx("div", {
                  className: "msgctr-participant-name",
                  children: map(otherParticipants, p => {
                    let name = p.Name;
                    if (p.Nickname) {
                      name += ` "${p.Nickname}"`;
                    }
                    return name;
                  }).join(', ')
                }), /*#__PURE__*/jsx("div", {
                  className: "msgctr-message-date",
                  children: formatSent(lastMessage)
                }), /*#__PURE__*/jsx("div", {
                  className: "msgctr-message",
                  dangerouslySetInnerHTML: {
                    __html: unformatLastMessage(lastMessage)
                  }
                })]
              })
            })]
          }), /*#__PURE__*/jsx(ListItemDelete, {
            onDelete: () => onDiscussionDelete(discussion)
          })]
        }, discussion.Id);
      })
    })]
  });
};
DiscussionInbox.propTypes = {
  discussions: PropTypes.array.isRequired,
  activeDiscussionId: PropTypes.string,
  onDiscussionSelect: PropTypes.func.isRequired,
  onDiscussionDelete: PropTypes.func.isRequired,
  studentPhotoEnabled: PropTypes.bool
};

class DiscussionInboxControls extends React.Component {
  static propTypes = {
    searchValue: PropTypes.string,
    onSearchChange: PropTypes.func.isRequired,
    onStartNewThread: PropTypes.func,
    isWritingNew: PropTypes.bool.isRequired
  };
  static defaultProps = {
    searchValue: ''
  };
  state = {
    search: ''
  };
  componentDidMount() {
    this.setState({
      search: this.props.searchValue
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.searchValue !== this.props.searchValue) {
      this.setState({
        search: this.props.searchValue
      });
    }
  }
  render() {
    return /*#__PURE__*/jsxs("div", {
      className: "msgctr-discussion-inbox-controls-comp",
      children: [this.props.onStartNewThread && /*#__PURE__*/jsx("div", {
        className: "msgctr-filter-wrapper",
        children: /*#__PURE__*/jsx("div", {
          className: "msgctr-position-wrapper",
          children: /*#__PURE__*/jsx(Button, {
            size: "large",
            variant: "contained",
            color: "primary",
            onClick: () => this.props.onStartNewThread(),
            disabled: this.props.isWritingNew,
            startIcon: /*#__PURE__*/jsx(FontAwesomeIcon, {
              fixedWidth: true,
              icon: faPencil
            }),
            children: "Compose"
          })
        })
      }), /*#__PURE__*/jsx("div", {
        className: "msgctr-search-wrapper",
        children: /*#__PURE__*/jsx("form", {
          className: "msgctr-position-wrapper",
          onSubmit: e => {
            e.preventDefault();
            this.props.onSearchChange(this.state.search);
          },
          children: /*#__PURE__*/jsx("div", {
            children: /*#__PURE__*/jsx(TextField, {
              id: "msgcntr-search-by-name",
              variant: "outlined",
              fullWidth: true,
              margin: "dense",
              value: this.state.search,
              label: "Search",
              onChange: e => this.setState({
                search: e.target.value
              }),
              InputProps: {
                endAdornment: /*#__PURE__*/jsx(FontAwesomeIcon, {
                  fixedWidth: true,
                  icon: faSearch
                })
              }
            })
          })
        })
      })]
    });
  }
}

class ContactTypeaheadResult extends React.Component {
  static propTypes = {
    avatarUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
    nickname: PropTypes.string,
    additionalDescription: PropTypes.string,
    description: PropTypes.string,
    selected: PropTypes.bool.isRequired,
    scid: PropTypes.number,
    collegeCrest: PropTypes.bool
  };
  static defaultProps = {
    selected: false,
    collegeCrest: false
  };
  render() {
    return /*#__PURE__*/jsx(AvatarWithTitle, {
      alignItems: 'center',
      avatar: this.props.collegeCrest ? /*#__PURE__*/jsx(CollegeCrest, {
        "aria-label": this.props.name,
        name: this.props.name,
        scid: this.props.scid,
        variant: "circular",
        size: "md"
      }) : /*#__PURE__*/jsx(AvatarWithFallback, {
        size: "md",
        variant: "circular",
        iconColor: ICON_COLOR.info,
        color: ICON_COLOR.info,
        sourceUrl: this.props.avatarUrl ? imageAsFullImageSrc(this.props.avatarUrl) : undefined,
        fallbackIcon: this.props.name.charAt(0) ?? '?',
        "aria-label": this.props.name,
        name: this.props.name
      }),
      title: /*#__PURE__*/jsx(Title, {
        children: this.props.name
      }),
      children: /*#__PURE__*/jsxs(Box, {
        children: [!isEmpty(this.props.nickname) && /*#__PURE__*/jsx(Typography, {
          variant: "body2",
          color: "textSecondary",
          children: /*#__PURE__*/jsx("strong", {
            children: `"${this.props.nickname}"`
          })
        }), /*#__PURE__*/jsxs(Box, {
          children: [/*#__PURE__*/jsx(Typography, {
            color: "textSecondary",
            variant: "body2",
            children: this.props.description
          }), this.props.additionalDescription && /*#__PURE__*/jsx(Typography, {
            color: "textSecondary",
            variant: "body2",
            children: this.props.additionalDescription
          })]
        })]
      })
    });
  }
}

class CounselorContactResult extends React.Component {
  static propTypes = {
    result: PropTypes.shape({
      AvatarUrl: PropTypes.string,
      Title: PropTypes.string,
      name: PropTypes.string.isRequired,
      selected: PropTypes.bool,
      HighSchoolName: PropTypes.string
    }).isRequired,
    withDefaultLabel: PropTypes.bool
  };
  render() {
    const {
      result,
      withDefaultLabel
    } = this.props;
    const defaultDescription = withDefaultLabel ? 'Counselor' : '';
    return /*#__PURE__*/jsx(ContactTypeaheadResult, {
      avatarUrl: result.AvatarUrl,
      name: result.name,
      selected: result.selected,
      description: result.Title || defaultDescription,
      additionalDescription: result.HighSchoolName
    });
  }
}

class ParentContactResult extends React.Component {
  static propTypes = {
    result: PropTypes.shape({
      AvatarUrl: PropTypes.string,
      name: PropTypes.string.isRequired,
      selected: PropTypes.bool
    }).isRequired,
    withDefaultLabel: PropTypes.bool
  };
  render() {
    const {
      result,
      withDefaultLabel
    } = this.props;
    const defaultDescription = withDefaultLabel ? 'Parent' : '';
    return /*#__PURE__*/jsx(ContactTypeaheadResult, {
      avatarUrl: result.AvatarUrl,
      name: result.name,
      selected: result.selected,
      description: defaultDescription
    });
  }
}

class RepContactResult extends React.Component {
  static propTypes = {
    result: PropTypes.shape({
      AvatarUrl: PropTypes.string,
      name: PropTypes.string.isRequired,
      CollegeName: PropTypes.string,
      OrganizationName: PropTypes.string,
      Scid: PropTypes.number,
      selected: PropTypes.bool
    }).isRequired
  };
  render() {
    const {
      result
    } = this.props;
    return /*#__PURE__*/jsx(ContactTypeaheadResult, {
      avatarUrl: result.AvatarUrl,
      name: result.name,
      selected: result.selected,
      description: result.CollegeName || result.OrganizationName,
      scid: result.Scid,
      collegeCrest: true
    });
  }
}

class StudentContactResult extends React.Component {
  static propTypes = {
    result: PropTypes.shape({
      AvatarUrl: PropTypes.string,
      name: PropTypes.string.isRequired,
      Nickname: PropTypes.string,
      Class: PropTypes.number,
      selected: PropTypes.bool
    }).isRequired,
    studentPhotoEnabled: PropTypes.bool
  };
  render() {
    const {
      result,
      studentPhotoEnabled
    } = this.props;
    return /*#__PURE__*/jsx(ContactTypeaheadResult, {
      avatarUrl: result ? getAvatar(result, studentPhotoEnabled) : '',
      name: result.name,
      nickname: result.Nickname,
      description: `Class of ${result.Class}`,
      selected: result.selected
    });
  }
}

const TYPE_TO_COLLECTION_KEY = {
  ParticipantHighSchoolStudent: 'Students',
  ParticipantCounselor: 'Counselors',
  ParticipantParent: 'Parents',
  ParticipantRep: 'Representatives'
};
const TYPE_TO_LABEL_KEY = {
  Vip: 'VIPs',
  ParticipantHighSchoolStudent: 'Students',
  ParticipantCounselor: 'Counselors',
  ParticipantParent: 'Parents',
  ParticipantRep: 'Contacts'
};
const RESULT_TYPE_COMPONENT = {
  ParticipantHighSchoolStudent: StudentContactResult,
  ParticipantCounselor: CounselorContactResult,
  ParticipantParent: ParentContactResult,
  ParticipantRep: RepContactResult
};
const renderResultByType = function (result) {
  let withDefaultLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let studentPhotoEnabled = arguments.length > 2 ? arguments[2] : undefined;
  let showCounselorSchool = arguments.length > 3 ? arguments[3] : undefined;
  const Component = RESULT_TYPE_COMPONENT[result.type];
  if (Component) {
    return /*#__PURE__*/jsx(Component, {
      result: result,
      withDefaultLabel: withDefaultLabel,
      studentPhotoEnabled: studentPhotoEnabled,
      showCounselorSchool: showCounselorSchool
    });
  }
};
const withPagination = (collection, type) => {
  const options = map(get(collection, 'Results', []), option => ({
    ...option,
    type
  }));
  if (get(collection, 'Disabled')) {
    options.push({
      disabledGroupMsg: true,
      type,
      name: `${TYPE_TO_LABEL_KEY[type]} cannot be added with the chosen recipients.`
    });
  }
  if (size(options) < get(collection, 'Total')) {
    options.push({
      type,
      showAll: true,
      paginationOption: true,
      name: `See All (${collection.Total})`
    });
  }
  return options;
};
class ContactTypeahead extends React.Component {
  static propTypes = {
    onSearch: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.arrayOf(PropTypes.object).isRequired,
    onLoadRemaining: PropTypes.func.isRequired,
    disabledResultsMessage: PropTypes.string,
    studentPhotoEnabled: PropTypes.bool,
    showCounselorSchool: PropTypes.bool
  };
  state = {
    options: [],
    searchText: '',
    disabledCollections: {},
    menuOpen: false
  };
  _typeahead = /*#__PURE__*/React.createRef();
  componentDidMount() {
    this.loadResults('');
  }
  componentDidUpdate(prevProps) {
    if (!this.props.disabledResultsMessage && !isEqual(prevProps.selected, this.props.selected)) {
      this.loadResults(this.state.searchText);
    }
  }
  handleSearch = newValue => {
    const trimmedValue = trimStart(newValue);
    this.loadResults(trimmedValue);
  };
  loadResults = value => {
    if (!this.props.disabledResultsMessage) {
      this.setState({
        searchText: value
      });
      this.props.onSearch(value).then(contacts => {
        this.setState({
          options: [...map(get(contacts, 'VIPs.Results'), result => ({
            ...result,
            type: result.Type,
            vip: true
          })), ...withPagination(contacts.Students, 'ParticipantHighSchoolStudent'), ...withPagination(contacts.Counselors, 'ParticipantCounselor'), ...withPagination(contacts.Parents, 'ParticipantParent'), ...withPagination(contacts.Representatives, 'ParticipantRep')],
          disabledCollections: reduce(TYPE_TO_COLLECTION_KEY, (result, collectionKey, type) => ({
            ...result,
            [type]: get(contacts, `${collectionKey}.Disabled`, false)
          }), {})
        });
      });
    }
  };
  showAllByType = (type, searchText) => {
    this.props.onLoadRemaining(TYPE_TO_COLLECTION_KEY[type], searchText).then(remainingOptions => {
      const formattedOptions = map(remainingOptions, option => ({
        ...option,
        type
      }));
      const idx = findIndex(this.state.options, option => option.type === type && option.showAll);
      const options = update(this.state.options, {
        $splice: [[idx, 1, ...formattedOptions]]
      });
      this.setState({
        options
      });
    });
  };
  render() {
    const selectedIds = map(this.props.selected, 'id');
    const disableSelectedOptions = map(this.state.options, (result, idx) => {
      const isSelected = includes(selectedIds, result.Value);
      return {
        ...result,
        disabled: result.Disabled || isSelected,
        selected: isSelected,
        position: idx,
        name: result.name || `${result.FirstName} ${result.LastName}`,
        id: result.Value,
        group: result.vip ? 'Vip' : result.type
      };
    });
    return /*#__PURE__*/jsx(Box, {
      mb: 1,
      maxWidth: "100%",
      children: /*#__PURE__*/jsx(Autocomplete, {
        id: "msgctr-contact-typeahead",
        options: disableSelectedOptions,
        value: this.props.selected,
        inputValue: this.state.searchText,
        onInputChange: (e, val, reason) => {
          if (reason === 'input') {
            this.handleSearch(val);
          }
        },
        onChange: (e, val, type) => {
          if (type === 'remove-option') {
            this.props.onSelect(val);
          }
          if (type === 'select-option') {
            if (val.at(-1).showAll) {
              this.showAllByType(val.at(-1).type, this.state.searchText);
              return;
            }
            if (val.at(-1).disabledGroupMsg) {
              return;
            } else {
              this.setState({
                searchText: ''
              });
              this.props.onSelect(val);
            }
          }
        },
        noOptionsText: "No matches found.",
        freeSolo: true,
        multiple: true,
        disableCloseOnSelect: true,
        closeIcon: null,
        getOptionDisabled: option => {
          if (this.props.disabledResultsMessage) return true;else {
            return option.disabled || this.state.disabledCollections[option.type];
          }
        },
        getOptionLabel: option => option.name,
        renderOption: option => {
          return /*#__PURE__*/jsxs(React.Fragment, {
            children: [option.showAll && /*#__PURE__*/jsx(Box, {
              color: "primary.main",
              children: /*#__PURE__*/jsx(Typography, {
                children: option.name
              })
            }), option.disabledGroupMsg && /*#__PURE__*/jsx(Box, {
              color: "error.main",
              children: /*#__PURE__*/jsx(Typography, {
                children: option.name
              })
            }), !option.showAll && !option.disabledGroupMsg && renderResultByType(option, option.vip, this.props.studentPhotoEnabled, this.props.showCounselorSchool)]
          });
        },
        renderInput: params => /*#__PURE__*/jsx(TextField, {
          ...params,
          label: "Enter recipient name",
          helperText: this.props.disabledResultsMessage ? this.props.disabledResultsMessage : '',
          variant: "outlined"
        }),
        open: this.state.menuOpen,
        onOpen: () => this.props.disabledResultsMessage ? this.setState({
          menuOpen: false
        }) : this.setState({
          menuOpen: true
        }),
        onClose: () => this.setState({
          menuOpen: false
        }),
        groupBy: option => option.group,
        renderGroup: params => {
          return /*#__PURE__*/jsxs(Box, {
            component: "li",
            p: 2,
            children: [/*#__PURE__*/jsx(Typography, {
              variant: "subtitle2",
              children: TYPE_TO_LABEL_KEY[params.group]
            }), /*#__PURE__*/jsx(Box, {
              component: "ul",
              p: 0,
              children: params.children
            })]
          }, params.key);
        }
      })
    });
  }
}

class SelectionCounter extends React.Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    restrictedMessage: PropTypes.string
  };
  render() {
    const {
      count,
      max,
      restrictedMessage
    } = this.props;
    return /*#__PURE__*/jsx(Box, {
      color: "primary.main",
      mb: 1,
      children: /*#__PURE__*/jsx(Typography, {
        align: "right",
        variant: "body2",
        children: restrictedMessage ? restrictedMessage : `${count} of ${max}`
      })
    });
  }
}

const groupRestrictionMessage = 'Contacts cannot participate in group direct message threads.';
const maxResultsMessage = 'You have reached the max limit of recipients.';
const maxRecipeints = 8;
class NewConversationStarter extends React.Component {
  static propTypes = {
    userId: PropTypes.string.isRequired,
    onConversationStart: PropTypes.func.isRequired,
    onContactSearch: PropTypes.func.isRequired,
    onLoadRemainingContacts: PropTypes.func.isRequired,
    renderMenuItemChildren: PropTypes.func,
    studentPhotoEnabled: PropTypes.bool,
    showCounselorSchool: PropTypes.bool
  };
  state = {
    recipients: []
  };
  render() {
    const {
      recipients
    } = this.state;
    const recipientCount = size(recipients);
    const selectedRecipientIds = map(recipients, 'id');
    const hasRep = some(recipients, recipient => recipient.type === 'ParticipantRep');
    const hasMaxedRecipients = recipientCount >= maxRecipeints;
    const disabledResultsMessage = hasRep ? groupRestrictionMessage : hasMaxedRecipients ? maxResultsMessage : undefined;
    return /*#__PURE__*/jsxs(Box, {
      children: [/*#__PURE__*/jsx(SelectionCounter, {
        count: recipientCount,
        max: maxRecipeints,
        restrictedMessage: disabledResultsMessage
      }), /*#__PURE__*/jsx(ContactTypeahead, {
        studentPhotoEnabled: this.props.studentPhotoEnabled,
        disabledResultsMessage: disabledResultsMessage,
        selected: recipients,
        onSelect: recipients => this.setState({
          recipients
        }),
        onSearch: term => this.props.onContactSearch(term, selectedRecipientIds),
        onLoadRemaining: (colletionKey, term) => this.props.onLoadRemainingContacts(colletionKey, term, selectedRecipientIds),
        showCounselorSchool: this.props.showCounselorSchool
      }), /*#__PURE__*/jsx(ConversationInputWithApi, {
        disabled: recipientCount === 0,
        participantIds: [this.props.userId, ...selectedRecipientIds],
        onAddMessage: (participants, newMessage) => this.props.onConversationStart(participants, newMessage)
      }), size(this.state.recipients) > 0 && /*#__PURE__*/jsx(Box, {
        mt: 1,
        fontStyle: "italic",
        children: /*#__PURE__*/jsx(Typography, {
          variant: "body2",
          color: "textSecondary",
          children: "*This message contains more than one recipient, use caution when sharing private details."
        })
      })]
    });
  }
}

class MessageDeletedModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };
  render() {
    return /*#__PURE__*/jsxs(DismissibleDialog, {
      open: this.props.show,
      headerText: "Message deleted",
      onClose: this.props.onClose,
      children: [/*#__PURE__*/jsx(DismissibleDialog.Body, {
        children: "The direct message thread has been deleted and cannot be viewed."
      }), /*#__PURE__*/jsx(DismissibleDialog.Footer, {
        children: /*#__PURE__*/jsx(DismissibleDialog.Footer.CloseButton, {
          children: "Close"
        })
      })]
    });
  }
}

const useDistanceFromTop = () => {
  const [top, setTop] = useState(0);
  const ref = useRef(null);
  useLayoutEffect(() => {
    if (ref.current === null) return;
    const handleResize = debounce(() => {
      var _a;
      setTop(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) || 0);
    }, 50);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return {
    ref,
    top
  };
};
const useHeightCSSToFillView = () => {
  const {
    ref,
    top
  } = useDistanceFromTop();
  return {
    ref,
    height: `calc(100vh - ${top}px)`
  };
};

const FillViewHeight = _ref => {
  let {
    children
  } = _ref;
  const {
    ref,
    height
  } = useHeightCSSToFillView();
  return (
    // @ts-expect-error ref is erroring about Box props
    jsx(Box, {
      ref: ref,
      height: height,
      children: children
    })
  );
};

const DEFAULT_STATE = Object.freeze({
  activeDiscussion: {
    OwnerId: '',
    Participants: []
  },
  discussions: [],
  conversation: [],
  viewSelected: false,
  isWritingNew: false,
  isDeletingDiscussion: false
});
const DEFAULT_PROPS = Object.freeze({
  filter: 'all',
  search: '',
  activeDiscussionId: '',
  canStartConversations: false,
  shouldConfirmDeletion: false,
  onSendError: noop
});
class MessageCenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...DEFAULT_STATE,
      isWritingNew: false,
      openDeletedDiscussionModal: false
    };
  }
  static propTypes = {
    className: PropTypes.string,
    userId: PropTypes.string.isRequired,
    filter: PropTypes.string,
    search: PropTypes.string,
    activeDiscussionId: PropTypes.string,
    updateUnreadMessageFlag: PropTypes.func.isRequired,
    onChangeActiveDiscussionId: PropTypes.func.isRequired,
    onDiscussionFiltersChange: PropTypes.func.isRequired,
    conversationFlowHeadingType: PropTypes.string,
    onLoadInbox: PropTypes.func.isRequired,
    onSearchInbox: PropTypes.func.isRequired,
    onMarkAsRead: PropTypes.func.isRequired,
    onLoadConversation: PropTypes.func.isRequired,
    onDeleteDiscussion: PropTypes.func.isRequired,
    shouldConfirmDeletion: PropTypes.bool,
    onAddMessage: PropTypes.func.isRequired,
    emptyConversationComponent: Conversation.propTypes.emptyConversationComponent,
    canStartConversations: PropTypes.bool.isRequired,
    avatarResolver: PropTypes.func,
    onContactSearch: PropTypes.func,
    onLoadRemainingContacts: PropTypes.func,
    renderMenuItemChildren: PropTypes.func,
    renderDiscussionParticipants: PropTypes.func,
    onSendError: PropTypes.func,
    errorMessage: PropTypes.string,
    studentPhotoEnabled: PropTypes.bool,
    realtimeConnect: PropTypes.func.isRequired,
    showCounselorSchool: PropTypes.bool,
    emptyStateHelper: PropTypes.bool,
    onNavigateToProfile: PropTypes.func
  };
  static defaultProps = DEFAULT_PROPS;
  inboxHasUpdated(discussions, warnWhenMissingDiscussion) {
    this.setState({
      discussions
    }, () => {
      if (some(discussions, {
        Id: this.props.activeDiscussionId
      })) {
        this.activeDiscussionChange(this.props.activeDiscussionId, discussions);
      } else {
        const newActiveId = get(discussions[0], 'Id', DEFAULT_PROPS.activeDiscussionId);
        this.props.onChangeActiveDiscussionId(newActiveId);
        if (this.props.activeDiscussionId && warnWhenMissingDiscussion) {
          this.setState({
            openDeletedDiscussionModal: true
          });
        }
      }
    });
  }
  loadInbox(filter, warnWhenMissingDiscussion) {
    this.props.onLoadInbox(filter).then(discussions => {
      this.inboxHasUpdated(discussions, warnWhenMissingDiscussion);
    }).catch(noop);
  }
  searchInbox(search) {
    this.props.onSearchInbox(search).then(discussions => {
      this.inboxHasUpdated(discussions);
    });
  }
  updateInbox(warnWhenMissingDiscussion) {
    if (this.props.search !== DEFAULT_PROPS.search) {
      this.searchInbox(this.props.search);
    } else {
      this.loadInbox(this.props.filter, warnWhenMissingDiscussion);
    }
  }
  processRealTimeMessage(newMessage) {
    if (this.state.activeDiscussion.Id === newMessage.DiscussionId && !some(this.state.conversation, {
      Id: newMessage.Message.Id
    })) {
      this.setState({
        conversation: [...this.state.conversation, newMessage.Message]
      });
    }
    this.updateInbox();
  }
  componentDidMount() {
    this.unregisterRealTimeListener = this.props.realtimeConnect(`${this.props.userId}-MessageCentre`, newMessage => this.processRealTimeMessage(newMessage));
    this.updateInbox(true);
  }
  componentWillUnmount() {
    this.unregisterRealTimeListener();
  }
  activeDiscussionChange(activeDiscussionId, discussions) {
    const found = find(discussions, {
      Id: activeDiscussionId
    });
    if (found) {
      const foundIdx = findIndex(discussions, {
        Id: activeDiscussionId
      });
      this.props.onMarkAsRead(found.Id).then(() => {
        const newDiscussions = update(discussions, {
          [foundIdx]: {
            Read: {
              $set: true
            }
          }
        });
        this.props.updateUnreadMessageFlag(some(newDiscussions, {
          Read: false
        }));
        this.setState({
          discussions: newDiscussions
        });
      });
      this.loadConversation(found.Id);
      this.setState({
        activeDiscussion: found
      });
    } else {
      this.setState({
        activeDiscussion: DEFAULT_STATE.activeDiscussion,
        conversation: []
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.search !== this.props.search) {
      if (trim(this.props.search) === '') {
        this.loadInbox();
      } else {
        this.searchInbox(this.props.search);
      }
    } else if (prevProps.filter !== this.props.filter) {
      this.loadInbox(this.props.filter);
    } else if (this.props.activeDiscussionId !== prevProps.activeDiscussionId) {
      this.activeDiscussionChange(this.props.activeDiscussionId, this.state.discussions);
    }
  }
  updateSearch(newSearch) {
    this.props.onDiscussionFiltersChange(DEFAULT_PROPS.filter, newSearch);
  }
  selectDiscussion(discussionId) {
    this.setState({
      isWritingNew: false,
      viewSelected: true
    });
    this.props.onChangeActiveDiscussionId(discussionId);
  }
  getParticipantNames(discussion) {
    const otherPeople = reject(discussion.Participants, person => person.ParticipantId === discussion.OwnerId);
    const names = map(otherPeople, person => person.Name);
    return names.join(', ');
  }
  openDeletionModal(discussion) {
    const participantsToDelete = this.getParticipantNames(discussion);
    this.setState({
      isDeletingDiscussion: true,
      participantsToDelete,
      deletionId: discussion.Id
    });
  }
  confirmDeletion(discussionId) {
    this.props.onDeleteDiscussion(discussionId).then(() => {
      if (this.props.shouldConfirmDeletion) {
        this.setState({
          isDeletingDiscussion: false,
          participantsToDelete: [],
          deletionId: undefined
        });
      }
      this.updateInbox();
    });
  }
  deleteDiscussion(discussion) {
    if (this.props.shouldConfirmDeletion) {
      this.openDeletionModal(discussion);
    } else {
      this.confirmDeletion(discussion.Id);
    }
  }
  loadConversation(discussionId) {
    this.props.onLoadConversation(discussionId).then(conversation => {
      this.setState({
        conversation,
        viewSelected: true
      });
    });
  }
  conversationStart(participants, msg) {
    this.props.onAddMessage(participants, msg).then(discussionId => {
      this.props.onLoadInbox(this.props.filter).then(discussions => this.inboxHasUpdated(discussions)).then(() => this.selectDiscussion(discussionId));
    });
  }
  renderDiscussionParticipants() {
    const participants = reject(this.state.activeDiscussion.Participants, p => {
      return !has(p, 'ParticipantId') || isEqual(p.ParticipantId, this.state.activeDiscussion.OwnerId);
    });
    return this.props.renderDiscussionParticipants(participants);
  }
  render() {
    const {
      activeDiscussion
    } = this.state;
    const inboxControlProps = {};
    const {
      onNavigateToProfile
    } = this.props;
    if (this.props.canStartConversations) {
      inboxControlProps.onStartNewThread = () => this.setState({
        isWritingNew: true,
        viewSelected: true
      });
    }
    return /*#__PURE__*/jsxs("div", {
      className: cn('msgctr-messages', this.props.className, {
        'msgctr-with-selected': this.state.viewSelected
      }),
      children: [/*#__PURE__*/jsx(Box, {
        className: "msgctr-inbox-wrapper",
        width: {
          sm: '250px',
          md: '375px'
        },
        children: /*#__PURE__*/jsx(FillViewHeight, {
          children: /*#__PURE__*/jsxs("div", {
            className: "left-rail-wrapper",
            children: [/*#__PURE__*/jsx(DiscussionInboxControls, {
              ...inboxControlProps,
              searchValue: this.props.search,
              onSearchChange: newSearch => this.updateSearch(newSearch),
              isWritingNew: this.state.isWritingNew
            }), /*#__PURE__*/jsx(DiscussionInbox, {
              studentPhotoEnabled: this.props.studentPhotoEnabled,
              discussions: this.state.discussions,
              activeDiscussionId: activeDiscussion.Id,
              onDiscussionSelect: discussion => this.selectDiscussion(discussion.Id),
              onDiscussionDelete: discussion => this.deleteDiscussion(discussion),
              onRequestAvatar: this.props.avatarResolver
            })]
          })
        })
      }), /*#__PURE__*/jsxs("div", {
        className: "msgctr-active-wrapper",
        children: [/*#__PURE__*/jsx("div", {
          className: "msgctr-small-screen-back-to-list",
          children: /*#__PURE__*/jsx(IconButton, {
            color: "primary",
            "aria-label": "back to list",
            onClick: () => this.setState({
              viewSelected: false,
              isWritingNew: false
            }),
            children: /*#__PURE__*/jsx(FontAwesomeIcon, {
              size: "sm",
              color: "inherit",
              icon: faArrowLeft
            })
          })
        }), /*#__PURE__*/jsx(FillViewHeight, {
          children: this.state.isWritingNew ? /*#__PURE__*/jsx(NewConversationStarter, {
            studentPhotoEnabled: this.props.studentPhotoEnabled,
            userId: this.props.userId,
            onContactSearch: this.props.onContactSearch,
            onLoadRemainingContacts: this.props.onLoadRemainingContacts,
            onConversationStart: (participants, msg) => this.conversationStart(participants, msg),
            renderMenuItemChildren: this.props.renderMenuItemChildren,
            showCounselorSchool: this.props.showCounselorSchool
          }) : /*#__PURE__*/jsx(Conversation, {
            ...inboxControlProps,
            conversation: this.state.conversation,
            conversationFlowHeadingType: this.props.conversationFlowHeadingType,
            studentPhotoEnabled: this.props.studentPhotoEnabled,
            readOnly: activeDiscussion.ReadOnly,
            participants: activeDiscussion.Participants,
            discussionOwnerId: activeDiscussion.OwnerId,
            emptyConversationComponent: this.props.emptyConversationComponent,
            errorMessage: this.props.errorMessage,
            emptyStateHelper: this.props.emptyStateHelper,
            onAddMessage: (participants, msg) => {
              this.props.onAddMessage(participants, msg).then(() => this.loadConversation(activeDiscussion.Id)).catch(err => this.props.onSendError(err));
            },
            onNavigateToProfile: onNavigateToProfile
          })
        })]
      }), !this.state.isWritingNew && this.props.renderDiscussionParticipants && some(activeDiscussion.Participants, p => has(p, 'ParticipantId')) && this.renderDiscussionParticipants(), this.props.shouldConfirmDeletion && /*#__PURE__*/jsxs(ConfirmationDialog, {
        open: this.state.isDeletingDiscussion,
        headerText: "Confirm delete",
        confirmationText: "Delete",
        onConfirm: () => this.confirmDeletion(this.state.deletionId),
        onClose: () => this.setState({
          isDeletingDiscussion: false
        }),
        children: [/*#__PURE__*/jsx(Typography, {
          children: "Do you want to delete this conversation with:"
        }), /*#__PURE__*/jsx(Typography, {
          children: /*#__PURE__*/jsx("strong", {
            children: this.state.participantsToDelete
          })
        })]
      }), /*#__PURE__*/jsx(MessageDeletedModal, {
        onClose: () => this.setState({
          openDeletedDiscussionModal: false
        }),
        show: this.state.openDeletedDiscussionModal
      })]
    });
  }
}
const ParticipantRail = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/jsx("div", {
    className: "msgctr-participant-container",
    children: /*#__PURE__*/jsx(FillViewHeight, {
      children: children
    })
  });
};
ParticipantRail.propTypes = {
  children: PropTypes.node
};
MessageCenter.ParticipantRail = ParticipantRail;

var participantTypes = {
  ParticipantParent: 'parent',
  ParticipantCounselor: 'counselor',
  ParticipantHighSchoolStudent: 'student',
  ParticipantRep: 'rep'
};

const useClasses = makeStyles(theme => ({
  tabs: {
    marginBottom: theme.spacing(1)
  },
  link: {
    '&:focus, &:active, &:hover': {
      textDecoration: 'none'
    }
  }
}));
const getInitial = function () {
  let links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let currentPath = arguments.length > 1 ? arguments[1] : undefined;
  let initial = 0;
  links.forEach((l, i) => {
    if (l.path === currentPath) initial = i;
  });
  return initial;
};
const NavigationWrapper = _ref => {
  let {
    links,
    children,
    linksClassName
  } = _ref;
  const [value, setValue] = useState(getInitial(links, window.location.pathname));
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useClasses();
  return /*#__PURE__*/jsxs("div", {
    className: "msgctr-navigation-wrapper",
    children: [/*#__PURE__*/jsx(Tabs, {
      value: value,
      onChange: handleChange,
      "aria-label": "engage presence sub menu",
      indicatorColor: "primary",
      textColor: "primary",
      className: cn(classes.tabs, linksClassName),
      variant: "scrollable",
      scrollButtons: "auto",
      children: map(links, (link, idx) => /*#__PURE__*/jsx(Tab, {
        component: Link,
        label: link.label,
        to: link.path,
        className: classes.link
      }, idx))
    }), /*#__PURE__*/jsx("div", {
      className: "msgctr-navigation-wrapper-children",
      children: children
    })]
  });
};
NavigationWrapper.propTypes = {
  links: PropTypes.array,
  children: PropTypes.node,
  linksClassName: PropTypes.string
};

const NotificationsInboxList = _ref => {
  let {
    activeNotificationId,
    canViewMore,
    notifications,
    onDelete,
    onNotificationSelect,
    onViewMore
  } = _ref;
  return /*#__PURE__*/jsxs("div", {
    className: "msgctr-notifications-inbox-list-comp",
    children: [notifications.map(notification => /*#__PURE__*/jsx(InboxItemPreview, {
      body: notification.Text,
      createdDate: notification.CreatedDate,
      subject: notification.Subject,
      isSelected: notification.Id === activeNotificationId,
      isUnread: notification.Status === 'unread',
      onSelect: () => onNotificationSelect(notification.Id),
      onDelete: onDelete ? () => onDelete(notification.Id) : undefined
    }, notification.Id)), canViewMore && /*#__PURE__*/jsx(Box, {
      p: 1,
      textAlign: "center",
      children: /*#__PURE__*/jsx(Button, {
        color: "primary",
        onClick: onViewMore,
        children: "View More"
      })
    })]
  });
};
NotificationsInboxList.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object).isRequired,
  onNotificationSelect: PropTypes.func.isRequired,
  onViewMore: PropTypes.func.isRequired,
  activeNotificationId: PropTypes.string,
  canViewMore: PropTypes.bool.isRequired,
  onDelete: PropTypes.func
};

const DEFAULT_DISPLAY_LIMIT = 3;
const getNameFromTarget = target => target.split(/\||>/)[1];
const formatDate = date => {
  return moment$1(date).format('dddd, MMMM Do YYYY, h:mma');
};
class NotificationItem extends React.Component {
  static propTypes = {
    notification: PropTypes.object,
    renderDestinationLink: PropTypes.func.isRequired
  };
  state = {
    toDisplayLimit: DEFAULT_DISPLAY_LIMIT
  };
  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.notification, prevProps.notification)) {
      this.setState({
        toDisplayLimit: DEFAULT_DISPLAY_LIMIT
      });
    }
  }
  getToTargets() {
    return take(this.props.notification.To, this.state.toDisplayLimit);
  }
  renderBody() {
    const {
      notification
    } = this.props;
    return /*#__PURE__*/jsxs("div", {
      className: "msgctr-body",
      children: [notification.TypeName === 'HTML' && /*#__PURE__*/jsx("div", {
        dangerouslySetInnerHTML: {
          __html: notification.HTML
        }
      }), (notification.TypeName === 'Text' || notification.TypeName === 'Destination') && notification.Text]
    });
  }
  renderItem() {
    return /*#__PURE__*/jsxs(React.Fragment, {
      children: [/*#__PURE__*/jsx("h3", {
        children: this.props.notification.Subject
      }), isCredibleDate(this.props.notification.CreatedDate) && /*#__PURE__*/jsx("div", {
        className: "msgctr-time-ago",
        children: formatDate(this.props.notification.CreatedDate)
      }), this.props.notification.From && /*#__PURE__*/jsxs("div", {
        className: "msgctr-from",
        children: [/*#__PURE__*/jsx("span", {
          className: "field-label",
          children: "From:"
        }), " ", getNameFromTarget(this.props.notification.From)]
      }), this.props.notification.From && /*#__PURE__*/jsxs("div", {
        className: "msgctr-to",
        children: [/*#__PURE__*/jsx("span", {
          className: "msgctr-field-label",
          children: "To:"
        }), /*#__PURE__*/jsxs("ul", {
          children: [map(this.getToTargets(), (target, idx, _ref) => {
            let {
              length
            } = _ref;
            return /*#__PURE__*/jsxs("li", {
              children: [getNameFromTarget(target), idx < length - 1 && ',']
            }, idx);
          }), this.state.toDisplayLimit < size(this.props.notification.To) && /*#__PURE__*/jsxs("li", {
            children: [/*#__PURE__*/jsx("span", {
              children: "and "
            }), /*#__PURE__*/jsxs("span", {
              className: "msgctr-show-more",
              onClick: () => this.setState({
                toDisplayLimit: size(this.props.notification.To)
              }),
              children: [size(this.props.notification.To) - this.state.toDisplayLimit, " more"]
            })]
          }, "more")]
        })]
      }), this.renderBody(), this.props.notification.TypeName === 'Destination' && /*#__PURE__*/jsx("div", {
        className: "msgctr-destination-link",
        children: this.props.renderDestinationLink(this.props.notification)
      })]
    });
  }
  render() {
    return /*#__PURE__*/jsx(Box, {
      className: "msgctr-notification-item-comp",
      p: {
        sm: '10px',
        md: '10px 30px'
      },
      children: this.props.notification && this.renderItem()
    });
  }
}

const emptyNotifications = /*#__PURE__*/jsx(BasicEmptyState, {
  title: 'All caught up',
  subTitle: 'No new notifications',
  icon: faCheck
});
class NotificationsCenter extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    activeItemId: PropTypes.string,
    renderDestinationLink: PropTypes.func.isRequired,
    onChangeActiveItemId: PropTypes.func.isRequired,
    onLoadInbox: PropTypes.func.isRequired,
    onMarkAsRead: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    onLoadItem: PropTypes.func.isRequired,
    emptyComponent: PropTypes.node
  };
  static defaultProps = {
    renderDestinationLink: noop,
    emptyComponent: emptyNotifications
  };
  state = {
    notifications: []
  };
  updateSelectedItem(activeItemId, notifications) {
    let selectedItem = find(notifications, {
      Id: activeItemId
    });
    if (!selectedItem && activeItemId) {
      this.props.onLoadItem(activeItemId).then(item => this.setState({
        selectedItem: item
      }));
    }
    this.setState({
      selectedItem
    });
  }
  setSelectedAsFirstItem(notifications, activeItemId) {
    if (!activeItemId && !isEmpty(notifications)) {
      const preselectedId = head(notifications).Id;
      this.markAsRead(preselectedId);
      this.props.onChangeActiveItemId(preselectedId);
    }
  }
  loadInbox() {
    let amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    return this.props.onLoadInbox(amount).then(result => {
      const notifications = result.Messages;
      this.setState({
        notifications: result.Messages,
        total: result.MessageCount
      });
      return notifications;
    });
  }
  loadInboxAndSelect(amount) {
    this.loadInbox(amount).then(notifications => {
      this.updateSelectedItem(this.props.activeItemId, notifications);
      this.setSelectedAsFirstItem(notifications, this.props.activeItemId);
    });
  }
  handleDelete = notificationId => {
    this.props.onDelete(notificationId).then(() => this.loadInbox(size(this.state.notifications))).then(() => {
      if (notificationId === this.props.activeItemId) {
        this.props.onChangeActiveItemId();
      }
    });
  };
  componentDidMount() {
    this.loadInboxAndSelect();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.activeItemId !== this.props.activeItemId) {
      if (this.props.activeItemId) {
        this.updateSelectedItem(this.props.activeItemId, this.state.notifications);
      } else {
        this.setSelectedAsFirstItem(this.state.notifications, this.props.activeItemId);
      }
    }
  }
  markAsRead(id) {
    this.props.onMarkAsRead(id);
    this.setState(update(this.state, {
      notifications: {
        $each: item => {
          if (item.Id === id) {
            return {
              ...item,
              Status: 'read'
            };
          }
          return item;
        }
      }
    }));
  }
  selectNotification(id) {
    this.markAsRead(id);
    this.props.onChangeActiveItemId(id);
    this.setState({
      viewSelected: true
    });
  }
  render() {
    return /*#__PURE__*/jsxs(InboxPageWrapper, {
      className: cn(this.props.className, {
        'msgctr-with-selected': this.state.viewSelected
      }),
      children: [/*#__PURE__*/jsx(InboxPageRail, {
        className: "msgctr-notification-page-rail",
        children: /*#__PURE__*/jsx(FillViewHeight, {
          children: /*#__PURE__*/jsx(NotificationsInboxList, {
            notifications: this.state.notifications,
            activeNotificationId: this.props.activeItemId,
            canViewMore: this.state.total > size(this.state.notifications),
            onViewMore: () => this.loadInbox(size(this.state.notifications) + 20),
            onNotificationSelect: id => this.selectNotification(id),
            onDelete: this.props.onDelete ? this.handleDelete : undefined
          })
        })
      }), /*#__PURE__*/jsxs(InboxPageMessageDisplay, {
        className: "msgctr-notification-page-display",
        children: [/*#__PURE__*/jsx(IconButton, {
          color: "primary",
          "aria-label": "back to list",
          onClick: () => this.setState({
            viewSelected: false,
            isWritingNew: false
          }),
          children: /*#__PURE__*/jsx(FontAwesomeIcon, {
            size: "sm",
            color: "inherit",
            icon: faArrowLeft
          })
        }), /*#__PURE__*/jsx(FillViewHeight, {
          className: "empty-state-fill-view-wrapper",
          children: size(this.state.notifications) === 0 ? this.props.emptyComponent : /*#__PURE__*/jsx(NotificationItem, {
            notification: this.state.selectedItem,
            renderDestinationLink: this.props.renderDestinationLink
          })
        })]
      })]
    });
  }
}
NotificationsCenter.DestinationLink;

const useStyles$1 = makeStyles(() => {
  return {
    avatar: {
      width: '40px',
      height: '40px'
    }
  };
});
const MessageAvatar = _ref => {
  let {
    name,
    scid
  } = _ref;
  const classes = useStyles$1();
  return jsx(CollegeCrest, {
    className: classes.avatar,
    "aria-label": name,
    name: name,
    scid: scid
  });
};

const useOpenClose = initialOpen => {
  const [open, setOpen] = useState(initialOpen);
  return {
    open,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false)
  };
};
const DeleteAction = _ref => {
  let {
    onDelete,
    senderName,
    subjectText
  } = _ref;
  const {
    open,
    onOpen,
    onClose
  } = useOpenClose(false);
  return jsxs("div", {
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
    },
    children: [jsx(IconButton, {
      "aria-label": `Delete message: ${subjectText}`,
      onClick: onOpen,
      children: jsx(FontAwesomeIcon, {
        icon: faTrashAlt,
        size: "xs"
      })
    }), jsx(ConfirmationDialog, {
      open: open,
      onConfirm: () => {
        onDelete && onDelete();
        onClose();
      },
      onClose: () => onClose(),
      headerText: `Delete this message from ${senderName}?`,
      confirmationText: "Delete",
      children: "This cannot be undone."
    })]
  });
};

const removeAllTags = value => {
  return sanitizeHtml(value, {
    allowedTags: [],
    allowedAttributes: {},
    transformTags: {}
  });
};

const useStyles = makeStyles(theme => ({
  summary: {
    width: '100%',
    padding: theme.spacing(3),
    paddingLeft: theme.spacing(5)
  },
  content: {
    width: '100%',
    margin: 0,
    '&.Mui-expanded': {
      margin: 0
    }
  },
  dash: {
    position: 'relative',
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1)
  },
  badge: {
    marginTop: '12px',
    marginLeft: '-12px',
    position: 'absolute'
  },
  subjectPreview: {
    color: theme.palette.text.primary
  },
  bodyPreview: {
    color: theme.palette.text.secondary,
    '& p': {
      display: 'inline'
    },
    '& a': {
      textDecoration: 'none'
    },
    '& a:hover': {
      textDecoration: 'underline'
    }
  },
  centerBox: {
    display: 'flex',
    alignItems: 'center'
  },
  regularBox: {},
  deselectedWrapper: {
    alignItems: 'flex-start'
  },
  selectedWrapper: {}
}));
const getDateStr = (date, isSelected) => {
  const fmt = isSelected ? 'ccc, MMM d, yyyy h:mm a' : 'MM/dd/yy';
  return format(new Date(date), fmt);
};
const MessagePreview = _ref => {
  let {
    subject: subjectText,
    body,
    isUnread,
    date,
    senderName,
    isSelected,
    onDeleteMessage
  } = _ref;
  const classes = useStyles();
  const subject = isSelected || !isUnread ? subjectText : jsx("strong", {
    children: subjectText
  });
  const dateStr = getDateStr(date, isSelected);
  return jsx(AccordionSummary, {
    className: classes.summary,
    "aria-label": `Message: ${subjectText}`,
    "aria-expanded": isSelected,
    classes: {
      content: classes.content
    },
    children: jsxs(Box, {
      className: isSelected ? classes.selectedWrapper : classes.deselectedWrapper,
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      children: [jsxs(Box, {
        className: isSelected ? classes.centerBox : classes.regularBox,
        flexGrow: 1,
        maxWidth: `calc(100% - ${isSelected ? 200 : 60}px)`,
        children: [!isSelected && isUnread ? jsx(Badge, {
          color: "error",
          variant: "dot",
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'left'
          },
          className: classes.badge,
          "aria-label": `Unread message: ${subjectText}`
        }) : null, isSelected ? jsx(Typography, {
          variant: "h6",
          component: "span",
          children: subject
        }) : jsxs(Box, {
          className: classes.bodyPreview,
          display: "inline-block",
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          children: [jsxs(Typography, {
            className: classes.subjectPreview,
            variant: "body1",
            component: "span",
            children: [subject, jsx("span", {
              className: classes.dash,
              children: "\u2013"
            })]
          }), jsx(Typography, {
            variant: "body1",
            component: "span",
            children: jsx("span", {
              className: classes.bodyPreview,
              dangerouslySetInnerHTML: {
                __html: removeAllTags(body || '')
              }
            })
          })]
        })]
      }), jsxs(Box, {
        minHeight: "24px",
        minWidth: isSelected ? 210 : 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        children: [jsx(Typography, {
          variant: "caption",
          color: "textSecondary",
          children: dateStr
        }), !isSelected ? null : jsx(Box, {
          ml: 2,
          children: jsx(DeleteAction, {
            senderName: senderName,
            subjectText: subjectText,
            onDelete: onDeleteMessage
          })
        })]
      })]
    })
  });
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const SenderListItem = _a => {
  var {
      name,
      messageSubject,
      unreadCount,
      selected,
      avatar,
      to,
      onClick
    } = _a,
    rest = __rest(_a, ["name", "messageSubject", "unreadCount", "selected", "avatar", "to", "onClick"]);
  return jsxs(ListItem, Object.assign({}, to ? {
    component: Link$1,
    href: to
  } : {
    onClick: () => onClick && onClick()
  }, {
    button: true,
    selected: selected,
    style: {
      color: 'inherit'
    },
    className: 'selected'
  }, rest, {
    children: [jsx(AvatarWithTitle, {
      width: 'calc(100% - 40px)',
      additionalBodyProps: {
        flexGrow: 0,
        width: 'calc(100% - 75px)'
      },
      avatar: avatar,
      title: jsx(Title, {
        children: name
      }),
      children: jsx(Box, {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        children: jsx(Box, {
          minWidth: 0,
          flexShrink: 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          children: jsx(Typography, {
            noWrap: true,
            variant: "body2",
            color: "textSecondary",
            children: messageSubject
          })
        })
      })
    }), jsx(Box, {
      ml: '10px',
      children: jsx(Badge, {
        badgeContent: unreadCount,
        color: "error"
      })
    })]
  }));
};

const SenderList = _ref => {
  let {
    items
  } = _ref;
  return jsx(List, {
    disablePadding: true,
    children: items.map(item => jsx(SenderListItem, {
      name: item.name,
      avatar: item.avatar,
      messageSubject: item.messageSubject,
      unreadCount: item.unreadCount,
      selected: item.selected,
      to: item.to,
      onClick: () => item.onClick && item.onClick(item)
    }, item.key || item.id))
  });
};

export { Conversation$1 as ConversationFlow, ConversationInput, InboxItemPreview, InboxPageMessageDisplay, InboxPageRail, InboxPageWrapper, MessageAvatar, MessagePreview, MessageCenter as Messages, NavigationWrapper, NotificationsCenter as Notifications, SenderList, SenderListItem, LABELS as participantLabels, participantTypes };
//# sourceMappingURL=index.js.map
